(function() {
  function initTroubleshootingFaq(section) {
    if (!section || section.dataset.troubleshootingFaqReady === 'true') {
      return;
    }

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ts-faq-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ts-faq-panel]'));
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-ts-faq-item]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    section.dataset.troubleshootingFaqReady = 'true';

    function closeItem(item) {
      var button = item.querySelector('[data-ts-faq-question]');
      var answer = item.querySelector('[data-ts-faq-answer]');

      item.classList.remove('is-open');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }

      if (answer) {
        answer.hidden = true;
      }
    }

    function openItem(item) {
      var panel = item.closest('[data-ts-faq-panel]');
      var button = item.querySelector('[data-ts-faq-question]');
      var answer = item.querySelector('[data-ts-faq-answer]');

      if (panel) {
        Array.prototype.slice.call(panel.querySelectorAll('[data-ts-faq-item].is-open')).forEach(function(openItemEl) {
          if (openItemEl !== item) {
            closeItem(openItemEl);
          }
        });
      }

      item.classList.add('is-open');

      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }

      if (answer) {
        answer.hidden = false;
      }
    }

    function ensureFirstItemOpen(panel) {
      if (!panel) {
        return;
      }

      if (panel.querySelector('[data-ts-faq-item].is-open')) {
        return;
      }

      var firstItem = panel.querySelector('[data-ts-faq-item]');

      if (firstItem) {
        openItem(firstItem);
      }
    }

    function activatePanel(targetId) {
      tabs.forEach(function(tab) {
        var isActive = tab.getAttribute('data-ts-faq-tab') === targetId;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function(panel) {
        var isActive = panel.getAttribute('data-ts-faq-panel') === targetId;

        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;

        if (isActive) {
          ensureFirstItemOpen(panel);
        }
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activatePanel(tab.getAttribute('data-ts-faq-tab'));
      });
    });

    items.forEach(function(item) {
      var button = item.querySelector('[data-ts-faq-question]');

      if (!button) {
        return;
      }

      button.addEventListener('click', function() {
        if (item.classList.contains('is-open')) {
          closeItem(item);
          return;
        }

        openItem(item);
      });
    });

    activatePanel(tabs[0].getAttribute('data-ts-faq-tab'));

    function restoreFaqFromHash() {
      var id = window.location.hash.slice(1);
      var item = items.find(function(candidate) { return candidate.id === id; });
      if (!item) return;
      activatePanel(item.closest('[data-ts-faq-panel]').dataset.tsFaqPanel);
      openItem(item);
      requestAnimationFrame(function() {
        var button = item.querySelector('[data-ts-faq-question]');
        button.focus({ preventScroll: true });
        item.scrollIntoView({ block: 'center' });
      });
    }
    tabs.forEach(function(tab, index) {
      tab.addEventListener('keydown', function(event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activatePanel(tabs[next].dataset.tsFaqTab);
        tabs[next].focus();
      });
    });
    window.addEventListener('hashchange', restoreFaqFromHash);
    restoreFaqFromHash();

  }

  function initAllTroubleshootingFaqs(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-troubleshooting-faqs]')) {
      initTroubleshootingFaq(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('[data-troubleshooting-faqs]')).forEach(function(section) {
      initTroubleshootingFaq(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllTroubleshootingFaqs(document);
    });
  } else {
    initAllTroubleshootingFaqs(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllTroubleshootingFaqs(event.target);
  });
})();
